import React, { useEffect, useState } from "react";
import {
  Chip,
  IconButton,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Button,
  Link,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Container,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { connect } from "react-redux";
import {
  fetchReportesPistolasTerminal,
  filtraReportesPistolas,
} from "../../redux/actions/reportes";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  esES,
} from "@mui/x-data-grid";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import DoneIcon from "@mui/icons-material/Done";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import _ from "lodash";

const HistorialReportes = ({
  reportePistolas,
  reportePistolasOriginal,
  fetchReportesPistolasTerminal,
  filtraReportesPistolas,
}) => {
  const [pistolaFilter, setPistolaFilter] = useState([]);
  const [pistolaFilterSelected, setPistolaFilterSelect] = useState("Todos");
  const [tipoFilter, setTipoFilter] = useState([]);
  const [tipoFilterSelected, tipoTipoFilterSelect] = useState("Todos");
  const [reporteSeleccionado, setReporteSeleccionado] = useState({});

  useEffect(() => {
    fetchReportesPistolasTerminal();
  }, []);

  useEffect(() => {
    let filtroPistolas = [];
    let filtroTipo = [];

    if (reportePistolasOriginal.length > 0) {
      reportePistolasOriginal.forEach((i) => {
        filtroPistolas.push(i.pistola);
        filtroTipo.push(i.tipo);
      });

      setPistolaFilter(["Todos", ...new Set(filtroPistolas)]);
      setTipoFilter(["Todos", ...new Set(filtroTipo)]);
    }
  }, [reportePistolasOriginal]);

  useEffect(() => {
    handleChangeFiltros();
  }, [tipoFilterSelected, pistolaFilterSelected]);

  const handleChangePistolaFiltro = ({ target }) => {
    setPistolaFilterSelect(target.value);
  };

  const handleChangeTipoFiltro = ({ target }) => {
    tipoTipoFilterSelect(target.value);
  };

  const handleSeleccionaReporte = (reporte) => {
    setReporteSeleccionado(reporte);
  };

  const handleCloseModal = () => {
    setReporteSeleccionado({});
  };

  const truncateDescripcion = (text) => {
    return text.length > 15 ? text.slice(0, 30 - 1) + "..." : text;
  };

  const handleChangeFiltros = () => {
    filtraReportesPistolas(pistolaFilterSelected, tipoFilterSelected);
  };

  const cols = [
    {
      field: "titulo",
      headerName: "Titulo",
      width: 200,
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      width: 300,
      renderCell: ({ row }) => (
        <>
          {truncateDescripcion(row.descripcion)}
          <IconButton
            aria-label="mas"
            onClick={() => handleSeleccionaReporte(row)}
          >
            <ZoomInIcon color="secondary" />
          </IconButton>
        </>
      ),
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha Creación",
      width: 160,
      type: "dateTime",
    },
    {
      field: "nombre_usuario",
      headerName: "Usuario Creación",
      width: 200,
    },
    {
      field: "pistola",
      headerName: "Pistola",
      width: 80,
    },
    {
      field: "terminal_nombre",
      headerName: "Terminal",
      width: 200,
    },
    {
      field: "tipo",
      headerName: "Tipo",
      width: 100,
    },
    {
      field: "deshabilita",
      headerName: "Estado Puesto",
      width: 200,
      renderCell: ({ row }) => {
        if (Boolean(row.deshabilita)) {
          return (
            <Chip
              variant="outlined"
              color="warning"
              label="Puesto Deshabilitado"
              icon={<NotInterestedIcon />}
            />
          );
        } else {
          return (
            <Chip
              variant="outlined"
              color="success"
              label="Puesto Habilitado"
              icon={<DoneIcon />}
            />
          );
        }
      },
    },
  ];

  return (
    <Grid2 container sx={{ p: 2 }}>
      <Dialog
        open={Object.keys(reporteSeleccionado).length}
        onClose={handleCloseModal}
        scroll="paper"
        fullWidth
      >
        <DialogTitle>{reporteSeleccionado.titulo}</DialogTitle>
        <DialogContent dividers={"paper"}>
          <DialogContentText>
            {reporteSeleccionado.descripcion}
          </DialogContentText>
          {reporteSeleccionado?.urlFotosEncontradas?.length > 0 && (
            <Divider sx={{ pt: 2 }}>Fotos Vinculadas</Divider>
          )}
          {reporteSeleccionado?.urlFotosEncontradas?.map((urlFoto) => (
            <Link
              variant="button"
              underline="none"
              color="secondary"
              sx={{ cursor: "pointer" }}
              href={urlFoto}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Typography>
                <CloudDownloadIcon />{" "}
                {urlFoto.split("/")[urlFoto.split("/").length - 1]}
              </Typography>
            </Link>
          ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseModal}
            variant="outlined"
            color="secondary"
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <Grid2 md={12} xs={12} sx={{ pb: 2 }}>
        <Typography variant="h4" component="p">
          Reportes Generados
        </Typography>
      </Grid2>
      <Grid2 md={6} xs={12} sx={{ p: 1 }}>
        <FormControl fullWidth>
          <InputLabel id="label-select-filtro-pistola">
            Filtro Pistola
          </InputLabel>
          <Select
            labelId="label-select-filtro-pistola"
            id="select-tipo-filtro-pistola"
            value={pistolaFilterSelected}
            label="Filtro Pistola"
            onChange={handleChangePistolaFiltro}
            color="secondary"
          >
            {pistolaFilter?.map((filtro, index) => (
              <MenuItem key={index} value={filtro}>
                {filtro}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid2>
      <Grid2 md={6} xs={12} sx={{ p: 1 }}>
        <FormControl fullWidth>
          <InputLabel id="label-select-filtro-tipo">Filtro Tipo</InputLabel>
          <Select
            labelId="label-select-filtro-tipo"
            id="select-tipo-filtro-tipo"
            value={tipoFilterSelected}
            label="Filtro Tipo"
            onChange={handleChangeTipoFiltro}
            color="secondary"
          >
            {tipoFilter?.map((filtro, index) => (
              <MenuItem key={index} value={filtro}>
                {filtro}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid2>
      <Grid2 md={12} xs={12}></Grid2>
      <Grid2 md={12} xs={12} sx={{ height: 300 }}>
        <DataGrid
          columns={cols}
          rows={reportePistolas}
          getRowId={(row) => row.id}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        />
      </Grid2>
    </Grid2>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    reportePistolas: state.reportes.reportePistolas,
    reportePistolasOriginal: state.reportes.reportePistolasOriginal,
  };
};

export default connect(mapStateToProps, {
  fetchReportesPistolasTerminal,
  filtraReportesPistolas,
})(HistorialReportes);
